import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.ApprovalReminderIconButton`

export default defineMessages({
  tooltipText: {
    id: `${scope}.tooltipText`,
    defaultMessage: 'Send approval reminder',
  },
  ariaLabel: {
    id: `${scope}.ariaLabel`,
    defaultMessage: 'Send approval reminder',
  },
  reminderSentToastTitle: {
    id: `${scope}.reminderSentToastTitle`,
    defaultMessage: 'Reminder sent',
  },
  reminderErrorToastTitle: {
    id: `${scope}.reminderErrorToastTitle`,
    defaultMessage: "Reminder couldn't be sent",
  },
  modelTitle: {
    id: `${scope}.modelTitle`,
    defaultMessage: 'Expense report',
  },
})
